import queryString from "query-string";
import { api, authHeader } from "../configs/axiosConfigs";
import { defineCancelApiObject } from "../configs/axiosUtils";

const DefaultApiService = {
  getApi: async (source, params, cancel = false) => {
    const response = await api.request({
      url: `${source}?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
      signal: cancel
        ? cancelApiObject["getApi"].handleRequestCancellation().signal
        : undefined,
    });

    return response?.data;
  },
  getListApi: async (source, params) => {
    const query =
      params && Object.keys(params).length
        ? `?${queryString.stringify(params)}`
        : "";
    const response = await api.request({
      url: `${source}/GetList${query}`,
      method: "GET",
      headers: authHeader(),
    });

    return response.data;
  },
  getOneApi: async (source, id) => {
    const hasId = id !== undefined && id !== null && id !== "";
    const response = await api.request({
      url: `${source}/GetById${hasId ? `?Id=${id}` : ""}`,
      method: "GET",
      headers: authHeader(),
    });

    return response.data;
  },
  modifyApi: async (source, data) => {
    console.log(data);
    const response = await api.request({
      url: `${source}/Modify`,
      method: "Post",
      data: data,
      headers: authHeader(),
    });
    console.log(response.data);
    return response.data;
  },
  postApi: async (source, data) => {
    const response = await api.request({
      url: `${source}`,
      method: "Post",
      data: data,
      headers: authHeader(),
    });

    return response.data;
  },
  deleteOneApi: async (source, data) => {
    const response = await api.request({
      url: `${source}/Delete`,
      method: "Delete",
      data,
      headers: authHeader(),
    });

    return response.data;
  },

  getCustomeApi: async (source) => {
    const response = await api.request({
      url: `${source}`,
      method: "GET",
      headers: authHeader(),
    });

    // Cancelled requests may resolve to undefined via axios error handler.
    return response?.data ?? null;
  },
  getDashboard: async (source) => {
    const response = await api.request({
      url: `${source}/Home/GetData`,
      method: "Get",
      headers: authHeader(),
    });

    return response.data;
  },
  uploadFile: async (files, moduleName) => {
    const formData = new FormData();
    formData.append("ModuleName", moduleName); // با حرف بزرگ M

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      formData.append(`Files`, file.file, file.name); // با حرف بزرگ F
    }
    const response = await api.request({
      url: "FileUploader/UploadByCollection",
      method: "Post",
      data: formData,
      headers: authHeader(),
    });

    return response.data;
  },
  uploadFiles: async (files, moduleName) => {
    const formData = new FormData();
    formData.append("ModuleName", moduleName); // با حرف بزرگ M

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      formData.append(`Files`, file.file, file.name); // با حرف بزرگ F
    }
    const response = await api.request({
      url: "FileUploader/UploadByCollection",
      method: "Post",
      data: formData,
      headers: authHeader(),
    });

    return response.data;
  },
  downloadFile: async (source) => {
    const response = await api.request({
      url: `${source}`,
      method: "GET",
      headers: authHeader(),
      responseType: "blob",
    });

    return response.data;
  },
};

const cancelApiObject = defineCancelApiObject(DefaultApiService);

export default DefaultApiService;
